import { render, staticRenderFns } from "./SelectCampaignsOfferSales.vue?vue&type=template&id=52d8aa6a&scoped=true"
import script from "./SelectCampaignsOfferSales.vue?vue&type=script&lang=js"
export * from "./SelectCampaignsOfferSales.vue?vue&type=script&lang=js"
import style0 from "./SelectCampaignsOfferSales.vue?vue&type=style&index=0&id=52d8aa6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d8aa6a",
  null
  
)

export default component.exports